import { NavLink } from "react-router-dom";
import { Icon } from "../design-system/Icon";
import { Avatar } from "../design-system/Avatar";
import { NAV_ITEMS, NAV_GROUPS, type NavItem } from "./navigation";
import { useAppStore } from "../state/app-store";
import { strings } from "../i18n/es-CL";

function groupedItems(): [NavItem["group"], NavItem[]][] {
  const order: NavItem["group"][] = ["executive", "commerce", "operations", "intelligence", "system"];
  return order.map((group) => [group, NAV_ITEMS.filter((i) => i.group === group)]);
}

export function Sidebar(): JSX.Element {
  const closeMobileNav = useAppStore((s) => s.closeMobileNav);
  return (
    <aside className="sidebar">
      <div className="sidebar__brand">
        <div className="sidebar__logo">
          <Icon name="bolt" size={20} strokeWidth={2} />
        </div>
        <div className="sidebar__brandtext">
          <div className="sidebar__name">{strings.appName}</div>
          <div className="sidebar__tag">{strings.appTagline}</div>
        </div>
      </div>

      <nav className="sidebar__nav" aria-label="Navegación principal">
        {groupedItems().map(([group, items]) => (
          <div className="sidebar__group" key={group}>
            <div className="sidebar__grouplabel">{NAV_GROUPS[group]}</div>
            {items.map((item) => (
              <NavLink
                key={item.id}
                to={item.path}
                end={item.path === "/"}
                className={({ isActive }) => `navlink${isActive ? " navlink--active" : ""}`}
                title={item.label}
                onClick={closeMobileNav}
              >
                <Icon name={item.icon} size={19} />
                <span className="navlink__label">{item.label}</span>
              </NavLink>
            ))}
          </div>
        ))}
      </nav>

      <div className="sidebar__foot">
        <div className="opcard">
          <Avatar name="Fabián Jiménez" />
          <div className="opcard__meta">
            <div className="opcard__name">Fabián Jiménez</div>
            <div className="opcard__role">{strings.operator}</div>
          </div>
        </div>
      </div>
    </aside>
  );
}
